import { useCallback } from "react";

import useRestMutation from "@/remoteState/useRestMutation";
import { ISearchResultsResponse } from "@/search/NewSearchPageMVP/types/ISearchResultsResponse";
import { AGATHA_ORIGIN } from "@/search/search.constants";
import { ITaxonomyTags } from "../../FilterPanel/filters/Topics/TaxonomyTags/TaxonomyTags.types";
import {
  getQuerySearchParams,
  mapSearchParamsToQueryString,
} from "./useFetchSearchResults.utils";

const useFetchSearchResults = ({
  searchParams,
  searchId,
  canModifyContentSettings,
  sendAdminContentSettings,
  selectedTaxonomyTags,
}: IUseFetchSearchResults) => {
  const urlSearchParams = getQuerySearchParams({
    searchParams,
    searchId,
    canModifyContentSettings,
    sendAdminContentSettings,
  });
  const resourceUrl = `${AGATHA_ORIGIN}/api/search/?${mapSearchParamsToQueryString(urlSearchParams)}`;

  const createTaxonomyTagsRequest = useCallback(() => {
    const payload = {
      taxonomy_tags: selectedTaxonomyTags,
    };
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    };

    return new Request(resourceUrl, requestConfig);
  }, [resourceUrl, selectedTaxonomyTags]);

  return useRestMutation(createTaxonomyTagsRequest) as [
    Function,
    {
      data: ISearchResultsResponse | undefined;
      loading: boolean;
      error: Error;
    },
  ];
};

export interface IUseFetchSearchResults {
  searchParams: URLSearchParams;
  searchId: string;
  canModifyContentSettings: boolean;
  sendAdminContentSettings: boolean;
  selectedTaxonomyTags: ITaxonomyTags;
}
useFetchSearchResults.displayName = "useFetchSearchResults";
export { useFetchSearchResults };
